
<div mat-dialog-content>
	<p>
		{{ this.data.message }}
	</p>
</div>

<div mat-dialog-actions [align]="'center'">
	<button [color]="'primary'" mat-flat-button mat-dialog-close i18n="Close Button@@messageDialogCloseButtonLabel">
		Close
	</button>
</div>
